export default "__VITE_ASSET__BpSshc1z__"